import React from "react";
import { useField } from "formik";
import { FormField } from "semantic-ui-react";

export default function MyTextInput({
  label,
  showError = true,
  showHighlightError = true,
  isShowErrorBeforeTouch = false,
  errorClasses = "error-message",
  isDisabled = false,
  isTextArea = false,
  maxLength,
  icon,
  ...props
}) {
  const [field, meta] = useField(props);
  return (
    <FormField
      style={{ margin: "10px 0" }}
      error={
        showHighlightError &&
        (isShowErrorBeforeTouch || meta.touched) &&
        !!meta.error
      }
      disabled={isDisabled}
      className={icon ? "display-flex" : ""}
    >
      {icon && (
        <div className="center-flex" style={{ width: "18%", marginRight: 10 }}>
          <img src={icon} alt="icon" />
        </div>
      )}
      <div style={{ width: icon ? "82" : "100%" }}>
        <label>{label}</label>
        {!isTextArea && <input {...field} {...props} maxLength={maxLength} />}
        {isTextArea && <textarea {...field} {...props} maxLength={maxLength} />}
        {showError && (isShowErrorBeforeTouch || meta.touched) && meta.error ? (
          <div className={errorClasses}>{meta.error}</div>
        ) : null}
      </div>
    </FormField>
  );
}
